import {
  ApiService,
  ParentModel,
  requestHelper,
  type AuthService,
  type PageModel,
  type ServiceStore,
} from '@blueprint/frontend-basics'

import { ShopDto } from '@/models/dtos/shop.dto.ts'

export class ShopService extends ApiService {
  private readonly backendURL: string

  constructor(
    serviceStore: ServiceStore,
    authService: AuthService,
    backendURL: string,
  ) {
    super(serviceStore, authService)
    this.backendURL = backendURL
  }

  public async listShops(
    page: number = 0,
    pageSize: number = 10,
  ): Promise<PageModel<ShopDto>> {
    const headers = await this.getAuthHeaders()
    const params = { page, pageSize }
    const response = await requestHelper.get(`${this.backendURL}/shop/`, {
      headers,
      params,
    })
    return ParentModel.fromPaginatedJson(response.data, ShopDto)
  }
}
